module.exports = require('./helpers/bundle-url').getBundleURL('c9iqF') + "workers.5131a838.js";